import createReducer from '../createReducer';

const initialState = {
    subscriptionEvents: [],
    subscriptionPlans: [],
    currentSubscription: null,
    currentPlan: null,
    planEvents: [],
    loading: false,
    error: null,
    
    // XHR states - Use TXHR
    getSubscriptionsXHR: null,
    createSubscriptionXHR: null,
    updateSubscriptionXHR: null,
    deleteSubscriptionXHR: null,
    getPlansXHR: null,
    createPlanXHR: null,
    updatePlanXHR: null,
    deletePlanXHR: null,
    getPlanEventsXHR: null,
    linkEventToPlanXHR: null
};

const reducer = createReducer('subscription', initialState);

export default reducer;
